( function () {
	'use strict';

	/* eslint-disable max-params */
	function ObsTable ( $location, moment, $attrs, _, logger, observationsApi, apiService, INFO, $modal, Session, TOOLTIP_MESSAGES, $, $q, obsService ) {
		var self = this;

		self.remaining       = new Array( 0 );
		self.pages           = 1;
		self.itemsPerPage    = 25;
		self.currentPage     = 1;
		self.searchFilter    = INFO.obsNoFilter;
		self.order           = false;
		self.colSpan         = 8;
		self.loggedInUser    = Session.getCredentials();
		self.listType        = $attrs.listType;
		self.observations    = [];
		self.feedbackEnabled = [];
		self.loading         = false;
		self.userId          = Session.getCredentials().userId;

		self.manageSelfObsViewTooltip = TOOLTIP_MESSAGES.manageSelfObsView;
		self.manageObsViewTooltip     = TOOLTIP_MESSAGES.manageObsView;

		// display: hide or show indicator
		// order: true = asc, false = desc
		self.sortingConfig = {
			'name' : {
				'display'   : false,
				'order'     : false,
				'sortField' : [ 'name' ]
			},

			'observee' : {
				'display'   : false,
				'order'     : false,
				'sortField' : [ 'observee.firstName', 'observee.lastName' ]
			},

			'observer' : {
				'display'   : false,
				'order'     : false,
				'sortField' : [ 'observer.firstName', 'observer.lastName' ]
			},

			'template' : {
				'display'   : false,
				'order'     : false,
				'sortField' : [ 'template.name' ]
			},

			'startDate' : {
				'display'   : true,
				'order'     : false,
				'sortField' : [ 'startDate' ]
			},

			'submitDate' : {
				'display'   : true,
				'order'     : false,
				'sortField' : [ 'submitDate' ]
			},

			'finalScore' : {
				'display'   : false,
				'order'     : true,
				'sortField' : [ 'finalScore' ]
			}
		};

		function getByObsType () {
			var dataFor = {
				'inprogress' : {
					'getQuery' : function () {
						return { 'partial' : true };
					},

					'getData' : function ( data ) {
						return data.filter( function ( observeData ) {
							return !observeData.inReview && observeData.observer.id === Session.getCredentials().userId;
						} );
					}
				},

				'inreview' : {
					'getQuery' : function () {
						return { 'partial' : true, 'inReview' : true };
					},

					'getData' : function ( data ) {
						return data.map( function ( observeData ) {
							observeData.originalData = angular.copy( JSON.parse( angular.toJson( observeData ) ) );
							return observeData;
						} );
					}
				},

				'submittedbyme' : {
					'getQuery' : function () {
						return { 'partial' : false };
					},

					'getData' : function ( data ) {
						return data.filter( function ( observeData ) {
							return observeData.observer.id === Session.getCredentials().userId;
						} );
					}
				},

				'submittedbyothers' : {
					'getQuery' : function () {
						return { 'partial' : false };
					},

					'getData' : function ( data ) {
						return data.filter( function ( observeData ) {
							return observeData.observer.id !== Session.getCredentials().userId;
						} );
					}
				}
			};

			return dataFor[ self.listType ];
		}

		function lookupFBPermissions ( item ) {
			return apiService.getUsersThatCanProvideFeedback( item.id ).then(
				function ( res ) {
					item.fbEnabled =  _.contains( res.data.data, self.loggedInUser.userId.toString() );
				}
			);
		}

		function fetchObservations () {
			var getByType = getByObsType();
			var query     = getByType.getQuery();

			self.loading = true;

			observationsApi.getObservationsByUser( query )
			.then( function ( data ) {
				self.loading = true;

				if ( data.length ) {
					self.observations = _.sortByOrder( getByType.getData( data ), [ 'startDate' ], [ false ] );
					self.pages        = Math.ceil( self.observations.length / self.itemsPerPage );
				}
			}, function () {
				self.observations    = [];
			} ).finally( function () {
				self.loading = false;
			} );
		}

		function previewObservation ( id, parameters ) {
			var params = $.param( parameters || { } );

			var url = '/observations/' + id;

			if ( self.listType === 'inprogress' ) {
				url = url + '/edit';
			}
			$location.path( url ).search( params );
		}

		function getPages ( collection ) {
			self.pages = Math.ceil( collection.length / self.itemsPerPage );

			return new Array( self.pages );
		}

		function changeSorting ( key ) {
			_.mapValues( self.sortingConfig, function ( value, keyObj ) {
				// hide all sort indicators
				value.display = false;

				if ( keyObj !== key ) {
					value.order = false;
				}
			} );

			// display sort indicator of selected column
			( self.sortingConfig[ key ] || {} ).display = true;

			// display display correct sort indicator
			// toggle current order
			if ( ( self.sortingConfig[ key ] || {} ).order ) {
				self.sortingConfig[ key ].order = false;
			} else {
				( self.sortingConfig[ key ] || {} ).order = true;
			}

			self.order = ( self.sortingConfig[ key ] || {} ).order;

			// sort collection
			self.observations = _.sortByOrder( self.observations, function ( resource ) {
				if ( key === 'observee' || key === 'observer' ) {
					var name  = resource[ key ].firstName.toLowerCase() + ' ' + resource[ key ].lastName.toLowerCase();

					return name;
				}

				if ( key === 'template' ) {
					return ( resource[ key ].name || '' ).toLowerCase();
				}

				return ( resource[ ( self.sortingConfig[ key ] || {} ).sortField ] || '' ).toLowerCase();
			}, [ ( self.sortingConfig[ key ] || {} ).order, ( self.sortingConfig[ key ] || {} ).order ] );
		}

		function getColSpan () {
			return self.colSpan;
		}

		function deleteObsModal ( obsId ) {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/observations/observations-list/obs-delete-modal.html',
				'controller'   : 'ObsDeleteModalController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'observationId' : function () {
						return obsId;
					}
				}
			} );

			modalInstance.result.then( function () {
				self.observations = self.observations.filter( function ( item ) {
					return item.id !== obsId;
				} );
			} );
		}

		function manageViewPriv ( obsId, obs ) {
			obs.onObsList = true;

			$modal.open( {
				'templateUrl'  : '/templates/observations/observations-list/obs-manage-priv-modal.html',
				'controller'   : 'ObsManagePrivModalController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'confirmInReviewObj' : function () {
						return {
							'observationId' : obsId,
							'passedObs'     : obs
						};
					}
				}
			} );
		}

		function hasDigitalSig ( obj ) {
			return Boolean( Object.keys( obj || {} ).length );
		}

		function getUserDigitalSigPD ( obs ) {
			function getPD ( pd ) {
				return ( pd.pdOwner === self.userId || obs.observee.id === self.userId && !pd.pdOwner ) && pd.type === 4;
			}

			return angular.extend( [], obs.masterPrescribedResources ).filter( getPD )[ 0 ];
		}

		function activate () {
			self.fetchObservations();
			logger.info( 'Obs Table activated.' );
		}

		self.fetchObservations         = fetchObservations;
		self.previewObservation        = previewObservation;
		self.getPages                  = getPages;
		self.changeSorting             = changeSorting;
		self.getColSpan                = getColSpan;
		self.deleteObsModal            = deleteObsModal;
		self.manageViewPriv            = manageViewPriv;
		self.lookupFBPermissions       = lookupFBPermissions;
		self.getValidSignature         = obsService.getValidSignature;
		self.hasDigitalSig             = hasDigitalSig;
		self.checkIfAllSigned          = obsService.checkIfSignatureComplete;
		self.getUserDigitalSigPD       = getUserDigitalSigPD;

		activate();
	}

	angular
		.module( 'app.observations' )
		.controller( 'ObsTableCtrl', ObsTable );

	ObsTable.$inject = [ '$location', 'moment', '$attrs', '_', 'logger', 'observationsApi', 'apiService', 'INFO', '$modal', 'Session', 'TOOLTIP_MESSAGES', '$', '$q', 'observationService' ];
} )();
